/** 格式化金额展示 */
export function formatYuan(amount) {
  const n = Number(amount) || 0
  return n.toFixed(2)
}
